import IGlassAreaMetaData from 'components/interfaces/IGlassAreaMetaData';
import { KRH_VERTICAL_SIDES } from 'services/constants/glassEdgeTreatmentTypes';
import { FLOAT } from 'services/constants/glassPropertyTypes';
import { LAMINATED } from 'services/constants/glassTreatmentTypes';
import { DEFAULT_MAX_WEIGHT } from 'services/constants/glassWidthCalculationDefaultValues';
import { MAX_WEIGHT } from 'services/constants/glassWidthCalculationTypes';

const getDefaultGlassAreaMetaData = (): IGlassAreaMetaData => ({
  calculationType: MAX_WEIGHT,
  edgeTreatmentType: KRH_VERTICAL_SIDES,
  glassPropertyType: FLOAT,
  glassTreatmentType: LAMINATED,
  index: 0,
  maxWeight: DEFAULT_MAX_WEIGHT,
  notice: '',
  quantity: null,
});

export default getDefaultGlassAreaMetaData;
